import React from "react";
import { useTranslation, Trans } from "react-i18next";
import { FieldErrors, UseFormRegister } from "react-hook-form";
import { InputsForm5 } from "../../../types/InputsForm5";

//scss
import "../../../scss/common.scss";
import "../../../scss/component.scss";
import { InputCheckbox } from "../../input/InputCheckbox";
import { InputRadio } from "../../input/InputRadio";
import {PlanSelectFormData} from "../../../types/planSelectForm";


type Props = {
  planSelectFormData: PlanSelectFormData,
  control: any;
  errors: FieldErrors;
  register: UseFormRegister<InputsForm5>;
}

const SectionOther: React.FC<Props> = (props) => {
  const { t, i18n } = useTranslation();
  return (
    <>
      <section>
        {/* その他確認事項について */}
          <h2 className="heading-2">{t("その他確認事項について")}</h2>
          <div className="card mb-20 mb-32-md">
            <h3 className="heading-3">
              {t("特別な配慮を必要とする方")}
              <span className="label-required ml-5">{t("必須")}</span>
            </h3>
            <p className="mb-20">
              {t("ご参加者の中に、健康を害している方、車椅子などの器具をご利用になっている方や心身に障がいのある方、食物アレルギー・動物アレルギーのある方、妊娠中の方、妊娠の可能性がある方、身体障害者補助犬（盲導犬、聴導犬、介助犬）をお連れの方その他特別の配慮を必要とする方がいる。")}
            </p>
            <div className="form-content-input">
              <div
                className={
                  "form-content-input-sexual" +
                  (props.errors.other?.need_consideration ? " error" : "")
                }
              >
                <InputRadio
                  name="other.need_consideration"
                  control={props.control}
                  radios={[
                    { label: t("いる"), value: "yes" },
                    { label: t("いない"), value: "no" },
                  ]}
                  options={{ required: true }}
                  isRow={true}
                ></InputRadio>
                {props.errors.other?.need_consideration && (
                  <p className="form-error_text">
                    {t("特別な配慮を必要されるかをご選択ください。")}
                  </p>
                )}
              </div>
            </div>
          </div>

        <div className="card mb-20 mb-32-md">
          <h3 className="heading-3">
            {t("添乗員の有無")}
          </h3>
          <div className="form-content-input">
            {props.planSelectFormData.sellerProduct?.tourConductor === "enabled" ? (<>{t("同行いたします")}</>) : (<>{t("同行いたしません")}</>)}
          </div>
        </div>

          <div className="card mb-20">
            <p className="mb-20">
              <a
                href={i18n.language === "ja" ? '/Conditions' : `/${i18n.language}/Conditions`}
                className="button-large-orange block"
                target="_blank"
                rel="noreferrer"
              >
                {t("旅行条件書を表示する")}
                <i className="icon-blank-white ml-5"></i>
              </a>
            </p>
            <div className="form-input-checkbox">
              <InputCheckbox
                name="other.agree"
                register={props.register}
                checkboxes={[
                  {
                    id: "other.agree",
                    label: "",
                    value: "yes"
                  },
                ]}
                options={{ required: true }}
                className={"form-input-checkbox-icon"}
              ></InputCheckbox>
              <span className="form-input-checkbox-text">
                <label htmlFor="other.agree.0">
                  {t("旅行条件書を表示し、表示された諸条件について同意する")}
                </label>
              </span>
            </div>
            {props.errors.other?.agree && (
              <p className="form-error_text c-red ta-c mt-4">
                {t("「同意する」にチェックをいれてください。")}
              </p>
            )}  
          </div>
      </section>
    </>
  );
};

export default SectionOther;